export class DocenteCard {
    id!: string;
    nome?: string;
    cognome?: string;
    nomeMaterie?: Array<string>;
    referente?: boolean;
    docenteClasseId?: string;
    consenso?: boolean;
}